import React from "react";
import "./passwordSuccess.css";
import { IoMdLock } from "react-icons/io";
import { CiCircleQuestion } from "react-icons/ci";
import { CheckSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PasswordSuccess() {
  const navigate = useNavigate();

  return (
    <div className="password-success">
      <main className="password-success-main">
        <div className="password-success-card">
          <div className="password-success-icon">
            <CheckSquare size={64} strokeWidth={1.5} />
          </div>
          <p className="password-success-text">Your password has been reset</p>
          <h2 className="password-success-title">Successfully</h2>
          <button
            className="password-success-btn"
            onClick={() => navigate("/sign-in")}
          >
            Log in
          </button>
        </div>
      </main>

      <footer className="password-success-footer">
        <span>© 2025 Halper. All right reserved.</span>
        <div>
          <a href="#"><IoMdLock /> Privacy</a>
          <a href="#"><CiCircleQuestion /> Get help</a>
        </div>
      </footer>
    </div>
  );
}
